import axios from 'axios';
import { useQuery } from 'react-query';

const apiUrl = () => process.env.REACT_APP_BASIX_API || '';

// item 303 — per-deal commission verification (Sales Bible). expected = the reasons the
// deal's flagged SKUs should pay (gated by the $1k floor); placed = the reasons actually
// accrued to the ledger. Mirrors the accrual engine so it can't drift.
export interface CommissionVerification {
  proposalId: string;
  floorMet: boolean;
  expected: string[]; // reason names: IOSales / SalesPO / ProjectLead / DevelopingPartner
  placed: string[];
}

export type VerificationStatus = 'na' | 'confirmed' | 'missing';

export interface VerificationView {
  status: VerificationStatus;
  expected: string[];
  placed: string[];
  missing: string[];
}

const useCommissionVerification = () => {
  const query = useQuery('commissionVerification', async (): Promise<Map<string, CommissionVerification>> => {
    const { data } = await axios.get<CommissionVerification[]>(`${apiUrl()}Commission/Verification`);
    return new Map(data.map((v) => [v.proposalId, v]));
  });

  const viewFor = (proposalId: string): VerificationView => {
    const v = query.data?.get(proposalId);
    if (!v || !v.floorMet || v.expected.length === 0) {
      return {
        status: 'na', expected: [], placed: v?.placed ?? [], missing: [],
      };
    }
    const missing = v.expected.filter((r) => !v.placed.includes(r));
    return {
      status: missing.length === 0 ? 'confirmed' : 'missing',
      expected: v.expected,
      placed: v.placed,
      missing,
    };
  };

  return { viewFor, isLoading: query.status === 'loading' };
};

export default useCommissionVerification;
